// extracted by mini-css-extract-plugin
export var alternative = "brochures-module--alternative--6eb75";
export var brochureCta = "brochures-module--brochure-cta--42be2";
export var brochureCta__content = "brochures-module--brochure-cta__content--820d1";
export var brochuresSection = "brochures-module--brochures-section--69497";
export var button = "brochures-module--button--e82cd";
export var grid = "brochures-module--grid--2acf1";
export var oilAndGas = "brochures-module--oil-and-gas--2c74c";
export var renewables = "brochures-module--renewables--51ae2";